import React, { useState } from "react";
import { ProColumns } from "@ant-design/pro-table/es/typing";
import { Button } from "antd";
import { PlusCircleOutlined, EditOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Table from "../../Common/Table";
import clsx from "clsx";
import { useMiddahTableGet, MiddahTableRow } from "../../../hooks/api/middot";
import { RequestData } from "@ant-design/pro-components";
import { SortOrder } from "antd/es/table/interface";
import {
  queryFilterParams,
  getSorterParams,
  getUserRequestPath,
} from "../../../utils";
import { useNavigate, useSearchParams } from "react-router";
import { useAuth, UserRoleType } from "../../../store/auth";

export const columns = (): ProColumns<MiddahTableRow>[] => [
  {
    title: "Middah Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    hideInSearch: true,
    render: (_, record: MiddahTableRow) => (
      <span style={{ textDecoration: "underline", color: "#262626" }}>
        {record.name}
      </span>
    ),
  },
  {
    title: "Avodot",
    dataIndex: "exercisesSize",
    key: "exercisesSize",
    sorter: true,
    hideInSearch: true,
  },
];

function ToolBar({ onCreate }: { onCreate: () => void }) {
  return [
    // <Button
    //   key="create"
    //   icon={<PlusCircleOutlined />}
    //   type="primary"
    //   onClick={(e) => {
    //     e.preventDefault();
    //     onCreate();
    //   }}
    // >
    //   Add Middah
    // </Button>,
  ];
}

export default function MiddahContent(): React.ReactNode | null {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();
  const [tableKey, setTableKey] = useState<number>(() => Date.now());
  const { t, i18n } = useTranslation();
  const [createOpen, setCreateOpen] = useState(false);
  const middahsGet = useMiddahTableGet();

  const isAdmin = user?.role
    ? getUserRequestPath(user.role as UserRoleType) === "admin"
    : false;

  const tableRequest = (
    {
      current,
      pageSize,
      ...args
    }: Record<string, string> & {
      pageSize?: number | undefined;
      current?: number | undefined;
      keyword?: string | undefined;
    },
    sorter: Record<string, SortOrder>,
  ): Promise<Partial<RequestData<MiddahTableRow>>> => {
    const newParams = queryFilterParams({
      page: current ? `${current}` : "1",
      pageSize: pageSize ? `${pageSize}` : "10",
      ...args,
      ...getSorterParams(sorter),
    });

    setSearchParams({ ...args, ...getSorterParams(sorter) }, { replace: true });
    return middahsGet
      .fetch({
        ...newParams,
      })
      .then((response) => {
        if (response) {
          return {
            data: response.data,
            success: true,
            total: response.total,
          };
        }

        return { data: [], success: false, total: 0 };
      });
  };

  return (
    <>
      <Table<MiddahTableRow>
        key={`${tableKey}-${i18n.language}`}
        resetKey={() => setTableKey(Date.now())}
        className={clsx("transparent")}
        headerTitle={t("pages.middah.tableName")}
        toolBarRender={() => [
          <ToolBar key="toolbar" onCreate={() => setCreateOpen(true)} />,
        ]}
        request={tableRequest}
        columns={columns()}
        actions={[
          isAdmin
            ? [
              "edit",
              ({ record }) => ({
                title: "Edit middah",
                onClick: (e: MouseEvent) => {
                  e.stopPropagation();
                  navigate(`${record.id}/edit`);
                },
              }),
            ]
            : [
              "view",
              ({ record }) => ({
                title: "View middah",
                onClick: (e: MouseEvent) => {
                  e.stopPropagation();
                  navigate(`${record.id}/edit`);
                },
              }),
            ],
        ]}
        search={{
          style: {
            display: "none",
          },
        }}
        options={{
          search: {
            name: "search",
            placeholder: "Search by Middah name",
            style: { width: 280 },
          },
        }}
        columnsState={{
          persistenceKey: "pro-table-middah",
          persistenceType: "localStorage",
        }}
      />
    </>
  );
}
